import { render, staticRenderFns } from "./top-message.vue?vue&type=template&id=5d58e258"
import script from "./top-message.vue?vue&type=script&lang=js"
export * from "./top-message.vue?vue&type=script&lang=js"
import style0 from "./top-message.vue?vue&type=style&index=0&id=5d58e258&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports